import {
  styled,
  TextField,
  Typography,
  Button,
  Box,
  Chip,
} from '@mui/material';

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.custom?.background2 || '#F5F5F5',
    borderRadius: '12px !important',
    fontSize: '16px',
    color: theme.custom?.text || '#03252E',
    '& fieldset': {
      border: 'none',
      borderRadius: '0px !important',
    },
    '&:hover fieldset': {
      borderColor: theme.custom?.primary || '#FF6A00',
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.custom?.primary || '#FF6A00',
      borderWidth: '1px',
    },
  },
}));

export const FieldLabel = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 700,
  marginBottom: 5,
  marginTop: 2,
  marginLeft: 10,
  color: theme.custom?.text,
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  fontWeight: 700,
  marginBottom: 10,
  color: theme.custom?.text,
}));

export const SwitchLabel = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 600,
  color: theme.custom?.text,
}));

export const SwitchDescription = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  color: theme.custom?.textLight || '#6D8085',
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'var(--fi-button, #03252E)',
  color: `var(--fi-button-text, ${theme.custom?.textCTA || '#FFFFFF'})`,
  fontWeight: 700,
  fontSize: '16px',
  width: '100%',
  '&:hover': {
    backgroundColor: 'var(--fi-button-hover, #01152E)',
  },
  '&:disabled': {
    backgroundColor: theme.custom?.background3 || '#EEEEEE',
    color: '#6D8085',
    border: `1px solid ${theme.custom?.stroke || '#E0E0E0'}`,
  },
}));

export const SecondaryButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'transparent',
  color: theme.custom?.text || '#333333',
  fontWeight: 700,
  fontSize: '16px',
  border: `1px solid ${theme.custom?.stroke || '#E0E0E0'}`,
  width: '100%',
  '&:hover': {
    backgroundColor: theme.custom?.background3 || '#EEEEEE',
  },
  '&:disabled': {
    backgroundColor: theme.custom?.background3 || '#EEEEEE',
    color: theme.custom?.text || '#333333',
    border: `1px solid ${theme.custom?.stroke || '#E0E0E0'}`,
  },
}));

export const ErrorText = styled(Typography)(({ theme }) => ({
  color: `var(--fi-danger, ${theme.custom?.primary || '#FF6A00'})`,
  fontSize: '12px',
  marginTop: '4px',
}));

export const TagInputContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.custom?.background2 || '#F5F5F5',
    borderRadius: '12px !important',
    fontSize: '16px',
    color: theme.custom?.text || '#03252E',
    '& fieldset': {
      border: 'none',
      borderRadius: '0px !important',
    },
    '&:hover fieldset': {
      borderColor: theme.custom?.primary || '#FF6A00',
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.custom?.primary || '#FF6A00',
      borderWidth: '1px',
    },
  },
}));

export const TagChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.custom?.background2 || '#F7F7F7',
  color: theme.custom?.text || '#03252E',
  border: `1px solid ${theme.custom?.stroke || '#E0E0E0'}`,
  '& .MuiChip-deleteIcon': {
    color: theme.custom?.text || '#03252E',
    '&:hover': {
      color: `var(--fi-danger, ${theme.custom?.primary || '#FF6A00'})`,
    },
  },
}));
